<template>
  <div class="container">
    <div class="content">
      <div class="screen">
        <dl>
          <label>已选：</label>
          <div class="list">
            <li v-for="(s, i) in filters" :key="i" v-show="s.list.filter(i => i.selected).length > 0" :title="`${s.list.filter(i => i.selected).map(j => j.title).join('/')}`">
              <span>{{`${s.title}: ${s.list.filter(i => i.selected).map(j => j.title).join('/')}`}}</span>
              <i @click="cancelItemlist(s)"></i>
            </li>
            <span v-for="(s, i) in filters" :key="`s${i}`" v-show="s.list.filter(i => i.selected).length > 0">
              <span class="subList" v-for="(c, ci) in s.list" :key="ci" v-show="c.list && c.list.filter(i => i.selected).length > 0"
                :title="`${c.list && c.list.filter(i => i.selected).map(j => j.title).join('/')}`">
                <span>{{`${c.title}: ${c.list && c.list.filter(i => i.selected).map(j => j.title).join('/')}`}}</span>
                <i @click="cancelItemlist(c)"></i>
              </span>
            </span>
            <li v-if="timeDayData.list.filter(i => i.selected).length > 0" :title="`${timeDayData.list.filter(i => i.selected).map(j => j.title).join('/')}`">
              <span>{{`${timeDayData.title}: ${timeDayData.list.filter(i => i.selected).map(j => j.title).join('/')}`}}</span>
              <i @click="delTimeData()"></i>
            </li>
          </div>
          <button class="filter" @click="toggleFilter()">
            <img src="@assets/img/common/filter.svg" alt="filter">
            <span>{{showFilter ? '收起筛选' : '展开筛选'}}</span>
            <img :src="showFilter ? icons.upward : icons.downward" alt="down">
          </button>
        </dl>
        <div class="line" v-show="showFilter"></div>
        <div v-show="showFilter">
          <div class="mb10 public" v-for="(items, index) in filters" :key="index">
            <ul>
              <label>{{items.title}}</label>
              <li :class="{showSelect : items.expand}" :ref="`filter${index}`">
                <span :class="{active: item.selected}" v-for="(item, index) in items.list" :key="index" @click="selectItem(item, items)">{{item.title}}</span>
              </li>
              <li class="btn" v-if="items.list.length > 10">
                <button @click="showSelect(items, `filter${index}`)" class="down">
                  <img :src="items.expand ? icons.upward : icons.downward" alt="icon">
                </button>
              </li>
            </ul>
            <ul v-for="(c, i) in items.list" v-show="c.selected && c.list && c.list.length > 0" :key="i">
              <label>{{c.title}}</label>
              <li :class="{showSelect : c.expand}" :ref="`filterson${index}_${i}`">
                <span :class="{active: ci.selected}" v-for="(ci, cd) in c.list" :key="cd" @click="selectItem(ci, c)">{{ci.title}}</span>
              </li>
              <li class="btn" v-if="c.list && c.list.length > 0 && calWidth('filterson'+index+'_'+i,c.list)">
                <button @click="showSelect(c, `filterson${index}_${i}`)" class="down">
                  <img :src="c.expand ? icons.upward : icons.downward" alt="icon">
                </button>
              </li>
            </ul>
          </div>
          <ul v-show="hasDay">
            <label class="public">发布时间</label>
            <li v-show="!this.start && !this.end">
              <span :class="{active: d.key === day.key}" v-for="(d, i) in days" :key="i" @click="selectDay(d)">{{d.title}}</span>
            </li>
            <date-picker v-show="!this.day.key" v-model="datePicker" range placeholder="    开始时间    ～    结束时间" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" confirm>
            </date-picker>
          </ul>
        </div>
      </div>
      <!-- 报道审核、我的报道样式 -->
      <div :class="['clueList',list && list.length === 0 ? 'empty' : '']">
        <div class="nav">
          <li>
            <!-- <div :class="{isOrigin: true, on: isOrigin}" @click="toggleOrigin()">
              {{isOrigin ? '取消只看原创' : '只看原创'}}
            </div> -->
            <div class="fresh" @click="fresh()">刷新</div>
          </li>
          <li class="upload creat" v-if="showCreate">
            <button @click="goCreate()">{{`新建${$_syscfg.publish}`}}</button>
          </li>
        </div>
        <div class="list">
          <empty :mTop="30" v-if="list && list.length === 0" :msg="`暂无${$_syscfg.publish}数据`" />
          <skeleton v-show="waiting"></skeleton>
          <ul :class="{warn: item.has_warning}" v-show="!waiting" v-for="(item, index) in list" :key="index">
            <img v-if="item.has_warning" src="@assets/img/common/warnTag.svg" alt="warn" class="warning">
            <div class="thumImg" :style="'background: url('+ item.cover +') no-repeat;'" @click="viewMedia(item)">
              <div v-show="isChrome" class="backDrop"></div>
              <div v-show="!isChrome" :style="'background: url('+ item.cover +') no-repeat;'" class="blur"></div>
              <p class="tags" v-if="item.has_avid_icon || item.has_kankan_icon || item.has_iditor_icon">
                <img v-if="item.has_avid_icon" src="@assets/img/index/tv.svg" alt="tv">
                <img v-if="item.has_kankan_icon" src="@assets/img/index/kankan.svg" alt="kankan">
                <img v-if="item.has_iditor_icon" src="@assets/img/index/dxgg.svg" alt="dxgg">
              </p>
              <img @error="imgError(item)" class="cover" :src="item.img_url || item.cover || defaultImg" alt="cover">
              <img v-if="item.play_icon - 0 === 1 && item.img_url" class="play" src="@assets/img/index/play.svg" alt="play">
            </div>
            <dl>
              <a href="#" @click.prevent="goDetail(item)">
                <h4 :class="{news: item.is_new == 1}">
                  <span class="title" :title="item.title">
                    {{item.title}}
                  </span>
                  <img src="@assets/img/common/tips.svg" alt="change" v-if="item.has_change - 0 === 1">
                  <img src="@assets/img/common/new.svg" alt="new" v-if="item.is_new - 0 === 1">
                  <img src="@assets/img/common/imgIcon.svg" alt="img" v-if="item.has_img - 0 === 1">
                  <img src="@assets/img/common/videoIcon.svg" alt="video" v-if="item.has_video - 0 === 1">
                  <img src="@assets/img/common/audioIcon.svg" alt="audio" v-if="item.has_sound - 0 === 1">
                  <img alt="技审未通过" title="技审未通过" class="verify-logo" v-if="item.has_audit&&item.has_audit==2" src="@assets/img/common/verify-fail.svg">
                </h4>
              </a>
              <li>{{item.content}}</li>
              <li class="smal">
                <span :class="{card: item.user_id != 0}" @click="showCard(item.user_id, $event)">
                  {{item.user_name}}
                </span>
                <span>{{item.add_time}}</span>
                <span v-if="item.column" class="publish">
                  {{`${item.column}`}}
                </span>
                <span @mouseenter="getDyhistory(item.id)" v-if="item.platform_key == 'dy'" class="dyPush">
                  {{`推抖音 ${item.push_num}`}}
                  <div class="pushlist" v-if="dyHistoryList.length > 0">
                    <p class="li" v-for="(pl, pli) in dyHistoryList" :key="pli">
                      <i class="title">{{pl.msg}}</i>
                      <i>{{pl.user_name}}</i>
                      <i class="time">{{pl.raw_add_time}}</i>
                    </p>
                  </div>
                </span>
                <!-- <span>
                  {{`被推送 ${item.push_list.length}`}}
                  <div class="pushlist" v-if="item.push_list.length > 0">
                    <p class="li" v-for="(pl, pli) in item.push_list" :key="pli">
                      <i class="title">{{pl.push_title}}</i>
                      <i>{{pl.user_name}}</i>
                      <i class="time">{{pl.raw_add_time}}</i>
                    </p>
                  </div>
                </span> -->
              </li>
            </dl>
            <div class="doubleCreat">
              <div class="line">
                <button class="success" v-if="item.platform_key == 'dy' && item.has_dy_btn" @click="toDy(item.id, index)">推抖音</button>
                <button class="success" v-if="item.copy" @click="copyReport(item.id, index)">复制</button>
                <button class="success" @click="copyMedia(item.id, index)">转发</button>
                <button v-if="item.has_view" @click="reviewMedia(item, index)">预览</button>
                <div v-if="item.has_stream_send" class="threePoint">
                  <i></i>
                  <div class="btn">
                    <span></span>
                    <ul>
                      <li @click="mediaSend(item.id, index)">{{`归档`}}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </ul>
        </div>
        <pages :page_count="page.pageCount" :index="page.pageIndex" :total="page.total"></pages>
      </div>
    </div>
    <pushBox ref="pushBox" />
  </div>
</template>

<script>
import { apis } from "@common/config";
import common from "@common/common";
import pushBox from "@components/pushBox";
import pages from "@components/pages";
import empty from "@components/empty";
import Vue from "vue";
import DatePicker from "vue2-datepicker";
import skeleton from "@components/skeleton";

export default {
  components: { pages, pushBox, empty, DatePicker, skeleton },
  watch: {
    datePicker: {
      deep: true,
      handler: function (n) {
        this.page.pageIndex = 1;

        this.start = common.stampToTime(n[0]);
        this.end = this.getDayEnd(n[1]);
        this.changeTime();
      }
    }
  },
  data() {
    return {
      controller: null,
      waiting: true,
      hasDay: false,
      isXnew: this.$store.state.isXnew,
      list: null,
      defaultImg: require("@assets/img/common/default.png"),
      page: {
        pageCount: 0,
        pageSize: 10,
        pageIndex: 1,
        total: 0
      },
      allSelected: false,
      select: false,
      backShow: false,
      showFilter: true,
      filters: [],
      expandedFilters: {}, // 用户记录已展开的类别，用于每次数据返回时保持状态
      filterOptions: {},
      days: [
        {
          title: "今天",
          key: 1
        },
        {
          title: "昨天",
          key: 2
        },
        {
          title: "前一周",
          key: 3
        }
      ],
      day: {},
      datePicker: "",
      start: "",
      end: "",
      searchOptions: {},
      sorts: [
        {
          title: "时间",
          key: "time",
          selected: true
        },
        {
          title: "被发送",
          key: "push_num",
          selected: false
        }
      ],
      pushBox: false,
      icons: {
        checker: require("@assets/img/interview/checker.svg"),
        checkerOn: require("@assets/img/interview/checkerOn.svg"),
        downward: require("@assets/img/common/xiala.svg"),
        upward: require("@assets/img/common/upward.svg")
      },
      selectedTag: "",
      showCreate: false,
      isOrigin: false, // 是否原创
      timeDayData: {
        title: "发布时间",
        list: []
      },
      isChrome: true,
      dyHistoryList: []
    };
  },
  methods: {
    calWidth(filter,list) {
      if(list.length > 0) {
        // console.log(12345,filter,this.$refs[filter])
        if(this.$refs[filter]){
          let width = this.$refs[filter][0].getBoundingClientRect().width;
          let w = 0
          if(this.$refs[filter][0].children.length > 0){
            for(let i = 0; i < this.$refs[filter][0].children.length; i++){
              w+=this.$refs[filter][0].children[i].getBoundingClientRect().width
            }
          }

          // console.log(w,width)

          if(w > width){
            return true
          }
          // console.log(width, w)
        }
      }
      
    },
    getDyhistory(id) {
      let info = {
        id: id
      }
      common
      .myFetch(apis.dyhistory,info)
      .then(r => {
          if (r) {
              console.log(r)
              this.dyHistoryList = r.list
          }
      });
    },
    toDy(id) {
      this.$dyScan(id).then(res => {
        if(res){
          this.getList();
        }
      })
    },
    mediaSend(id, index) {
      this.list[index].showThreePoint = false;
      let info = {
          subject_type: 5,
          subject_id: id
      };
      common
      .myFetch(apis.streamMediaSend, info)
      .then(r => {
          if (r) {
              this.$toast(r)
          }
      });
    },
    setShowThreePoint(index) {
      this.list.forEach((el,key) => {
        if(key != index){
          el.showThreePoint = false;
        }
      });
      this.list[index].showThreePoint = !this.list[index].showThreePoint      
    },
    deepCopy(obj) {
      // 判断传入的值是否为一个对象
      if (obj === null && typeof obj !== "object") {
        return obj;
      }
      // 判断对象的类型 注意这里不考虑包装类对象
      if (Object.prototype.toString.call(obj) === "[object Date]") {
        return new Date(obj);
      }
      if (Object.prototype.toString.call(obj) === "[object RegExp]") {
        return new RegExp(obj);
      }
      if (Object.prototype.toString.call(obj) === "[object Undefined]") {
        return new Error(obj);
      }
      // 判断对象是类
      let newObj = Array.isArray(obj)  ? [] : {}
      for(let item in obj){
        if(typeof obj[item] === 'object') {
            newObj[item] = this.deepCopy(obj[item])
        }else {
            newObj[item] = obj[item]
        }
      }
      return newObj
    },
    reviewMedia(item, index) {
      if(item.platform_key == 'new_media_knews' || item.platform_key == 'five_star_sports_cms'){
        this.$PreviewKnews(item.id)
      }else if(item.platform_key == 'bilibili'){
        this.$PreviewBili(item.id)
      }else{
        this.list[index].showThreePoint = false;
        // console.log(item)
        let res = this.deepCopy(item)
        // let res = item
        res.platformType = res.platform_key
        res.content = res.content_html
        this.$PreviewBox(res)
      }
      // console.log(item)
    },
    showCard(id, e) {
      if (id == 0) return;

      const el = e.target;

      this.$card(id, el);
    },
    getDayEnd(s) {
      // 获取当天的结束时间
      if (!s) {
        return "";
      }
      const year = s.getFullYear();
      const month = common.doubleDigit(s.getMonth() + 1);
      const day = common.doubleDigit(s.getDate());

      return `${year}-${month}-${day} 23:59:59`;
    },
    delTimeData() {
      // 删除时间选择
      this.timeDayData = {
        title: "发布时间",
        list: []
      };

      if (this.start || this.end) {
        this.datePicker = "";
      } else {
        this.day = {};
        this.calculatefitlers();
      }
    },
    // 刷新
    fresh() {
      // 无修改刷新列表
      this.getList();
    },
    imgError(i) {
      // 图片加载状态
      this.$set(i, "img_url", this.defaultImg);
    },
    goDetail(i) {
      // 去详情页
      this.$set(i, "has_change", 0);
      this.$set(i, "is_new", 0);
      common.jump(`/mediaPublishDetail?d=${i.id}`, true);
    },
    async copyMedia(id,index) {
      // 复制报道
      const type = await this.$MediaPlatform('copy');
      if (!type) return;
      this.list[index].showThreePoint = false;
      const info = {
        id: id,
        platforms: type
      };

      const newWindow = window.open();

      common.myFetch(apis.newMediaPlatformMyCopy, info).then(r => {
        if (r) {
          newWindow.location.href = `${window.location.origin
            }/editMediaPublish?d=${r.report_id}`;

          // common.jump(`/editReport?d=${r.id}`, true)
        }
      });
    },
    //只看原创
    toggleOrigin() {
      this.isOrigin = !this.isOrigin;
      this.getList();
    },
    goViewLink(i) {
      if (i.url) {
        window.open(i.url);
      }
    },
    async viewMedia(item) {
      let list = await common.myFetch(apis.File_status, {
        subject_id: item.id,
        subject_type: 5
      })
      common.openMaterialBox(list, null, false);
    },
    changeTime() {
      this.calculatefitlers();
    },
    selectDay(d) {
      this.page.pageIndex = 1;

      if (d.key === this.day.key) {
        this.day = {};
      } else {
        this.day = d;
      }

      this.calculatefitlers();
    },
    addTimeData(n) {
      const timeObj = {
        days: "",
        start: "",
        end: ""
      };

      const timeFilterObj = {
        title: "发布时间",
        list: []
      };

      if (this.day.key) {
        timeObj.days = this.day.key || "";

        const dayTitle = this.day.title;
        const dayObj = {
          title: dayTitle,
          selected: true
        };
        timeFilterObj.list.push(dayObj);
      }

      if (this.start || this.end) {
        timeObj.start = this.start;
        timeObj.end = this.end;

        const dayObj = {
          title: `${timeObj.start.split(" ")[0]}~${timeObj.end.split(" ")[0]}`,
          selected: true
        };
        timeFilterObj.list.push(dayObj);
      }

      this.timeDayData = timeFilterObj;
      Object.assign(this.filterOptions, timeObj);
    },
    pushKK(id) {
      // const config = {
      //   msg: "是否添加knews套件？",
      //   alpha: {
      //     title: "添加",
      //     handle: () => {
      //       this.postKK(id, 1);
      //     }
      //   },
      //   beta: {
      //     title: "不添加",
      //     handle: () => {
      //       this.postKK(id, 0);
      //     }
      //   }
      // };

      // this.$ask(config);

      const config = {
        id: id
      }

      this.$kkType(config).then((res) => {
        if(res!=999){
          this.postKK(id, res)
        }
      })
    },
    postKK: (id, type) => {
      const info = {
        id: id,
        three: type
      };

      common.myFetch(apis.toKK, info).then(r => {
        if (r) {
          Vue.prototype.$toast(r);
        }
      });
    },
    toggleFilter() {
      // 切换筛选框
      this.showFilter = !this.showFilter;
    },
    switchSort(i) {
      // 切换筛选
      if (i.selected) return;

      this.sorts.forEach(s => {
        this.$set(s, "selected", false);
      });

      this.$set(i, "selected", true);
      this.filterOptions["sort_by"] = i.key;
      this.getList();
    },
    selectAll() {
      // 全选／反选 列表项
      const pushlist = this.list.filter(l => {
        if (l.has_push) {
          return l;
        }
      });

      this.allSelected = !this.allSelected;

      pushlist.forEach(i => {
        this.$set(i, "selected", this.allSelected);
      });

      if (pushlist.length !== this.page.pageSize) {
        let msg = "已选中有发送权限的条目";
        if (pushlist.length === 0) {
          msg = "暂无可发送的条目";
        }

        this.$toast(msg);
        this.allSelected = false;
      }
    },
    selectOne(i) {
      // 选择／反选 列表项
      if (!i.has_push) {
        this.$toast("无发送权限，无法选中");
        return;
      }

      this.$set(i, "selected", !i.selected);

      this.$nextTick(() => {
        if (!i.selected) {
          this.allSelected = false;
        }
      });
    },
    showSelect(i, key) {
      // 展开／关闭收起某类
      this.$set(i, "expand", !i.expand);

      this.$nextTick(() => {
        this.$set(this.expandedFilters, i.key, i.expand);

        if (!i.expand) {
          this.$refs[key][0].scrollTop = 0;
        }
      });
    },
    selectItem(i, l) {
      // 选择／反选 过滤项
      this.page.pageIndex = 1;

      this.$set(i, "selected", !i.selected);
      this.calculatefitlers();
    },
    cancelItemlist(l) {
      // 取消某类条件
      this.page.pageIndex = 1;

      l.list.forEach(i => {
        this.$set(i, "selected", false);
        i.list &&
          i.list.forEach(c => {
            this.$set(c, "selected", false);
          });
      });

      this.$nextTick(() => {
        this.calculatefitlers();
      });
    },
    calculatefitlers() {
      // 整理过滤项为接口格式，请求接口
      // this.filters.forEach(f => {
      //   let _this = this;
      //   const ids = f.list
      //     .map(i => {
      //       let that = _this;
      //       if (i.selected) {
      //         if (!i.list || i.list.length === 0) {
      //           return i.id;
      //         } else {
      //           let _that = that;
      //           const allId = i.list
      //             .map(c => {
      //               if (c.selected) {
      //                 return c.id;
      //               }
      //             })
      //             .filter(k => k)
      //             .join(",");
      //           _that.filterOptions[i.key] = allId || "";
      //           return i.id;
      //         }
      //       }
      //     })
      //     .filter(j => j)
      //     .join(",");
      //   this.filterOptions[f.key] = ids || "";
      // });
      this.filters.forEach(i => {
        const selected1 = [] // 一级已选
        let selected2 = [] // 二级已选
        let key2 = ''
        i.list.forEach(c => {
          if (c.selected) {
            selected1.push(c.id || c.key)
          }else{
            if(c.list){
              c.list.forEach( s => {
                s.selected = false;
              })
            }
          }

          if (c.list) {
            const subSelected = []
            key2 = c.key
            c.list.forEach( s => {
              if (s.selected) {
                subSelected.push(s.id)
              }
            })
            selected2 = selected2.concat(subSelected)
          }
        })

        this.filterOptions[i.key] = selected1.join(',')
        if (key2) this.filterOptions[key2] = selected2.join(',')
      })

      this.addTimeData();
      this.getList();
    },
    getViewNum(info) {
      // 异步读取浏览数据并赋值
      const data = {
        data: info,
        hideLoading: true
      };

      common.myFetch(apis.Rpt_viewnum, data).then(r => {
        if (r) {
          const viewData = r.list;
          (this.list || []).forEach(i => {
            if (viewData[i.idstring]) {
              this.$set(i, "view_num", viewData[i.idstring].count);
              this.$set(i, "link", viewData[i.idstring].url);
            }
          });
        }
      });
    },
    getList(keyWord) {
      if (this.controller) {
        this.controller.abort(); // 终止之前的请求
      }

      this.controller = new AbortController(); // 创建新的 AbortController
      const signal = this.controller.signal; // 获取信号

      this.waiting = true;
      this.list = null;
      let data = {
        search_option: "",
        key_words: "",
        column_fid: "",
        column_sid: "",
        days: "",
        tag_id: "",
        has_file: "",
        create_from: this.isOrigin ? 0 : 1,
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      };

      if(keyWord == 'noKeyWord'){
        this.searchOptions.key_words = ''
      }else{  
        this.searchOptions.key_words = this.$store.state.keyWord
      }

      Object.assign(data, this.filterOptions, this.searchOptions);
      common.myFetch(apis.newMediaPlatformList, {data: data,signal: signal}).then(res => {
        if (res) {
          console.log(res)
          this.allSelected = false;
          res.list.forEach(el => {
            el.showThreePoint = false;
          })
          this.list = res.list;
          // const info = {
          //   time_start: res.time_start,
          //   time_end: res.time_end
          // }
          // this.getViewNum(info)
          res.params.list_search.forEach(i => {
            // 返回的数据添加已展开状态，保持列表状态
            i.expand = this.expandedFilters[i.key];
            i.list &&
              i.list.forEach(j => {
                j.expand = this.expandedFilters[j.key];
              });
          });

          res.params.list_search.forEach(el => {
            if(el.key == 'days'){
              this.hasDay = true
            }
          })

          this.filters = res.params.list_search.filter(
            i => i.key != "days" && i.key != "start" && i.key != "end"
          );

          this.autoSelectTag();
          this.generateSearchs(res.params.top_search.option.list);
          this.$set(
            this.page,
            "pageCount",
            common.calculatePage(res.page.row_count - 0, this.page.pageSize)
          );
          this.$set(this.page, "total", res.page.row_count - 0);
          // this.showCreate = true
          this.showCreate = res.has_add_role;

          this.$nextTick(() => {
            this.waiting = false;
          })
        }
      });
    },
    autoSelectTag() {
      // 自动选中标签（从详情页回来时）
      if (!this.selectedTag) return;

      const tags = this.filters.filter(i => i.key === "tag_id")[0].list;
      let tag = {};
      tags.forEach(i => {
        if (this.selectedTag === i.title) {
          tag = i;
        }
      });

      this.selectedTag = "";
      this.selectItem(tag);
    },
    generateSearchs(data) {
      // 整理搜索栏数据
      const types = data.map(i => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        };
      });

      const filterData = {
        types: types,
        callback: o => {
          this.getSearch(o);
        }
      };
      this.postSearch(filterData);
    },
    getSearch(d) {
      // 接收搜索框数据
      this.searchOptions = d;
      this.page.pageIndex = 1;
      this.getList();
    },
    postSearch(data) {
      // 发送搜索框数据
      this.$emit("filterData", data);
    },
    push(id) {
      this.$refs.pushBox.open(id);
    },
    pushPatch() {
      const ids = this.list
        .filter(i => {
          if (i.selected) {
            return i;
          }
        })
        .map(j => j.id)
        .join(",");
      if (!ids) {
        this.$toast("请至少选择一项");
        return;
      }

      this.push(ids);
    },
    async goCreate() {
      const type = await this.$MediaPlatform();
      if (!type) return;

      common.jump(`/createMediaPublish?d=${type}`, true);
    }
  },
  beforeDestroy() {
    this.$AiMessage(true)
  },
  mounted() {
    var agent = navigator.userAgent.toLowerCase();
    if(agent.indexOf("chrome") > 0) {
      this.isChrome = true
    }else{
      this.isChrome = false
    }
    this.defaultImg = this.$_syscfg.default_img
    this.selectedTag = this.$route.params.tag;
    this.getList('noKeyWord');
    this.$AiMessage()
  }
};
</script>

<style src="@assets/css/reportEditor/reportEditor.less" lang="less" scoped>
</style>

<style lang="less" scoped>
.threePoint {
  margin: 0 0 0 5px;
}
.doubleCreat {
  padding-left: 10px !important;
  box-sizing: border-box;
}
.thumImg {
  .cover {
        object-fit: contain !important;
        background-color: #ECEEEE;
  }
}

.thumImg {

  background-position: center center !important;
  background-size: 100% 100% !important;

  .blur {
    width: 100%;
    height: 100%;
    filter: blur(5px);
    background-position: center center !important;
    background-size: 100% 100% !important;
  }
  .backDrop {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(5px);
  }

  .cover {
    position: absolute;
    top: 0;
    left: 0;
    background: transparent;
  }
}
</style>
